<article
  class="hd-not-self-card"
  [style.background]="info().cardColor"
>
  <!-- TOP ROW: rank (left) + focus badge (right) -->
  <div class="hd-not-self-card__top-row">
    <div class="hd-not-self-card__rank-block">
      <span class="hd-not-self-card__rank-number">{{ rank() }}</span>
      <span class="hd-not-self-card__rank-label">{{ impactRankLabel() }}</span>
    </div>

    <div class="hd-not-self-card__focus-block">
      <div class="hd-not-self-card__focus-badge">
        @for (glyph of focusConfig().glyphs; track $index) {
          <span class="hd-not-self-card__focus-glyph">{{ glyph }}</span>
        }
        <span class="hd-not-self-card__focus-short">{{ focusConfig().short }}</span>
      </div>
      <span class="hd-not-self-card__focus-keynote">{{ focusKeynote() }}</span>
    </div>
  </div>

  <!-- CENTRE CLUSTER: image + name (+ large glyph), centered as one group -->
  <div class="hd-not-self-card__cluster">
    <div
      class="hd-not-self-card__image-wrap"
      [style.width.%]="imageWidthPct()"
      [style.aspect-ratio]="imageAspect()"
    >
      @if (info().colorGroupOrder !== null) {
        <span class="hd-not-self-card__color-order">{{ info().colorGroupOrder }}</span>
      }
      <img
        class="hd-not-self-card__image"
        [src]="imageSrc()"
        [alt]="centerLabel()"
      />
    </div>

    <div class="hd-not-self-card__center-name">{{ centerLabel() }}</div>

    @if (info().hasLargeGlyph) {
      <span class="hd-not-self-card__large-glyph">{{ focusConfig().glyphs[0] }}</span>
    }
  </div>

  <!-- BOTTOM ROW: undefined % (left) + gate count (right) -->
  <div class="hd-not-self-card__bottom-row">
    <div class="hd-not-self-card__undefined-block">
      <span class="hd-not-self-card__bottom-number">{{ info().undefinedPopulationLabel }}</span>
      <span class="hd-not-self-card__bottom-label">{{ undefinedLabel() }}</span>
    </div>
    <div class="hd-not-self-card__gates-block">
      <span class="hd-not-self-card__bottom-number">{{ gateCount() }}</span>
      <span class="hd-not-self-card__bottom-label">{{ gatesLabel() }}</span>
    </div>
  </div>
</article>
